import {createNumberFormat} from '../../common/formatters';
import {Security} from '../../models/security';
import {
    getSymbolDecimalPlaces,
    getSymbolPrecisions,
    SymbolDecimalPlaces,
    SymbolDecimalPlacesWithStore,
    SymbolFormats
} from './symbol-decimals';
import NumberFormat = Intl.NumberFormat;

export class CachedSymbolFormats implements SymbolFormats {

    public get quantityFormat(): NumberFormat {
        return this._quantityFormat
            || (this._quantityFormat = createNumberFormat({
                isDecimalRequired: true,
                decimalCount:      this.decimalPlaces.quantity,
                precision:         this.precision.quantity
            }));
    }

    public get quantityStoreFormat(): NumberFormat {
        return this._quantityStoreFormat
            || (this._quantityStoreFormat = createNumberFormat({
                isDecimalRequired: true,
                decimalCount:      this.decimalPlaces.quantity,
                maxDecimalCount:   this.decimalPlaces.store.quantity,
                precision:         this.precision.quantity
            }));
    }

    public get reportFormat(): NumberFormat {
        return this._reportFormat
            || (this._reportFormat = createNumberFormat({
                isDecimalRequired: true,
                decimalCount:      this.decimalPlaces.report,
                maxDecimalCount:   this.decimalPlaces.store.report,
                precision:         this.precision.report
            }));
    }

    public get priceFormat(): NumberFormat {
        return this._priceFormat
            || (this._priceFormat = createNumberFormat({
                isDecimalRequired: true,
                decimalCount:      this.decimalPlaces.price,
                precision:         this.precision.price
            }));
    }

    public get quantityWithDecimalFormat(): NumberFormat {
        return this._quantityWithDecimalFormat
            || this.quantityFormat;
    }

    public get reportWithDecimalFormat(): NumberFormat {
        return this._reportWithDecimalFormat
            || this.reportFormat;
    }

    public get priceWithDecimalFormat(): NumberFormat {
        return this._priceWithDecimalFormat
            || this.priceFormat;
    }

    private _quantityFormat: NumberFormat;
    private _quantityStoreFormat: NumberFormat;
    private _reportFormat: NumberFormat;
    private _priceFormat: NumberFormat;
    private _quantityWithDecimalFormat: NumberFormat;
    private _reportWithDecimalFormat: NumberFormat;
    private _priceWithDecimalFormat: NumberFormat;

    constructor(
        private security: Security,
        public readonly decimalPlaces: SymbolDecimalPlacesWithStore = getSymbolDecimalPlaces(security),
        public readonly precision: SymbolDecimalPlaces = getSymbolPrecisions(security)
    ) {}

}
